<template>
  <v-app>
    <v-container>
      <v-card color="card1">
        <v-card-title>Home</v-card-title>
      </v-card>
      <vue-clock class="mx-16 my-8 d-flex justify-center" />
    </v-container>
  </v-app>
</template>

<script>
import VueClock from '@dangvanthanh/vue-clock'
export default {
  title: 'Home',
  components: { VueClock },
  computed: {
    events () {
      return this.$store.getters.loadTodayEvent
    }
  }
}
</script>

<style>

</style>
